import styled from 'styled-components';

export const SkeletonWrapper = styled.div`
  text-align: center;
`;

export const Hr = styled.hr<{ type: string }>`
  border-top: 1px ${p => p.type} black;
  width: 100%;
  margin: 4px 0px;
`;

export const RowTableInfo = styled.div`
  display: flex;
  justify-content: space-between;
  position: relative;
  width: 100%;
  height: fit-content;
`;
